import { useMutation } from "@tanstack/react-query";
import { ArchiveArchiveIndexSet } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
const updateRanges = async () => ArchiveArchiveIndexSet.rebuildIndexRanges();
const useArchiveIndexSetRangesMutation = () => {
  const rebuild = useMutation({
    mutationFn: updateRanges,
    onError: (errorThrown) => {
      UserNotification.error(
        `Recalculating Archive Index Ranges failed with status: ${errorThrown}`,
        "Could not recalculate Archive Index Ranges"
      );
    },
    onSuccess: () => {
      UserNotification.success("Archive Index Ranges will be recalculated shortly.", "Success!");
    }
  });
  return {
    rebuildArchiveIndexSetRangesMutation: rebuild.mutateAsync
  };
};
export default useArchiveIndexSetRangesMutation;
